import fauxSelectView from './fauxSelectComponent.html';
import './fauxSelectComponent.css';
import _ from 'lodash';
import quillIcon from 'quill/assets/icons/dropdown.svg';

export function fauxSelectComponent() {
	return {
		bindings: {
			values: '<',
			model: '=',
			width: '@',
			theme: '@',
		},
		controllerAs: 'vm',
		controller: fauxSelectComponentCtrl,
		template: fauxSelectView,
		transclude: true,
	};
}

export class fauxSelectComponentCtrl {
	constructor($element, $timeout) {
		'ngInject';
		this.$timeout = $timeout;
		this.chosen = $element[0].querySelector('.fs-chosen');
		this.options = $element[0].querySelector('.fs-options');
		this.isOpen = false;
		this.quillIcon = quillIcon;
		this.theme = this.theme || 'sharpr';
		this.listenForEscapeKey();
	}

	listenForEscapeKey() {
		this.closeOnEscapeKey = evt => {
			if (this.isOpen && evt.keyCode == 27) {
				this.$timeout(() => {
					this.toggle();
				});
			}
		};
		document.addEventListener('keydown', this.closeOnEscapeKey, false);
	}

	$onDestroy() {
		document.removeEventListener('keydown', this.closeOnEscapeKey);
	}

	$postLink() {
		this.$timeout(() => {
			// we still have to wait for any transcluded ng-repeat to run
			this.updateFromModel();
		}, 0);
	}

	$onChanges() {
		if (this.options.children.length > 0) {
			this.updateFromModel();
		}
	}

	toggle() {
		this.isOpen = !this.isOpen;
	}

	updateFromModel() {
		const idx = this.values.indexOf(this.model);
		this.setActive(idx);
	}

	choose(evt) {
		const idx = _.toArray(this.options.children).indexOf(evt.target);
		this.setActive(idx);
	}

	setActive(idx) {
		_.forEach(this.options.children, el => {
			el.classList.remove('selected');
		});
		const chosen = this.options.children[idx];
		// chosen might be null if initial indexOf returns -1
		if (chosen) {
			// update the chosen element
			this.chosen.innerHTML = '';
			this.chosen.appendChild(chosen.cloneNode(true));
			// update select to show it selected
			chosen.classList.add('selected');
			this.model = this.values[idx];
		}
		this.isOpen = false;
	}

	getCssWidth() {
		if (!this.width) {
			return 'auto';
		}
		if (String(this.width).match(/^[\d.]+$/)) {
			return `${this.width}px`;
		}
		return this.width;
	}
}
